

(function waitForCollectionData() { 
  const interval = setInterval(function () {
    const el = document.getElementById("collection-data");
    const menuLinks = document.querySelectorAll('.header__menu-item');
    const megamenuLinks = document.querySelectorAll('.megamenu--block-list-item a');
    if (!el) return;

    clearInterval(interval);

    const collectionHandle = el.dataset.handle;
    const collectionTitle = el.dataset.title;

    if (!collectionHandle || !collectionTitle) return;

    const currentCollection = {
      collection_handle: collectionHandle,
      collection_title: collectionTitle
    };

   // ✅ Convert full URLs to handles only
  const rootHandles = [
    "core-bore-core-cut-diamond-products-parts",
    "multiquip-parts",
    "wacker-parts-rammer-tampers-vibrators-neuson",
    "tsurumi-pump-parts",
    "makita-parts",
    "be-pressure-equipment-parts",
    "northrock-parts",
    "oztec-parts-and-accessories",
    "mbw-repair-parts",
    "tamco-toku-air-tool-parts",
    "allmand-parts",
    "allen-engineering-parts",
    "norton-clipper-parts",
    "wyco-parts",
    "edco-parts",
    "sullair-parts",
    "mi-t-m-parts",
    "large-brooms-wafers-accessories",
    "apt-american-pneumatic-tool-parts",
    "marshalltown-power-trowel-parts",
    "tripods-grade-rods-amp-accessories",
    "concrete-diamond-blades",
    "core-drill-bits",
    "other-fall-safety-items",
    "husqvarna-parts",
    "general-equipment-parts",
    "atlas-copco-chicago-pneumatic-dynapac-parts-1",
    "chicago-pneumatic-parts",
    "apt-american-pneumatic-tool-parts",
    "atlas-copco-parts",
    "wanco-replacement-parts",
    "jenny-air-compressor-repair-parts",
    "equipment-parts",
    "accessories",
    "large-brooms-wafers-accessories", 
    "topcon-accessories", 
    "tripods-grade-rods-amp-accessories",
    "diamond-tools-amp-supplies",
    "concrete-diamond-blades", 
    "core-drill-bits",
    "safety-items",
    "other-fall-safety-items",
    "pipe-plug-test-equipment", 
    "other-fall-safety-items",
    "frd-kent-parts",
    "bosch-parts",
    "genuine-kohler-oem-parts",
    "genuine-kawasaki-oem-parts",
  ];

  console.log("✅ Updated rootHandles:", rootHandles);



    // ✅ Check if the current handle is one of the root-level collections
    const isRootCollection = rootHandles.includes(collectionHandle);

    // ✅ If yes, reset breadcrumb
    if (isRootCollection) {
      deleteCookie("collectionData");
      const collectionArray = [currentCollection];
      setCookie("collectionData", JSON.stringify(collectionArray), 7);
      window.collectionData = collectionArray;
      console.log("Reset: Started breadcrumb at root collection", window.collectionData);
      return;
    }

    // Cookie functions
    function getCookie(name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length === 2) return decodeURIComponent(parts.pop().split(";").shift());
    }

    function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/;";
    }

    function deleteCookie(name) {
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    // ✅ If menu handle matches: reset and add current collection
    if (!getCookie("collectionData")) {
      // If no breadcrumb exists, start fresh
      const collectionArray = [currentCollection];
      setCookie("collectionData", JSON.stringify(collectionArray), 7);
      window.collectionData = collectionArray;
      
      console.log("🔰 Starting breadcrumb with:", window.collectionData);
      return;
    }

    // ✅ Else: normal push logic
    let existingData = getCookie("collectionData");
    let collectionArray = [];

    if (existingData) {
      try {
        collectionArray = JSON.parse(existingData);
      } catch (e) {
        console.warn("Invalid cookie JSON. Resetting.");
      }
    }

    const existingIndex = collectionArray.findIndex(item => item.collection_handle == currentCollection.collection_handle);

    if (existingIndex !== -1) {
      // Navigated BACK — trim to the existing item
      collectionArray = collectionArray.slice(0, existingIndex + 1);
    } else {
      // Navigated FORWARD (new collection) — add new level
      collectionArray.push(currentCollection);
    }

    setCookie("collectionData", JSON.stringify(collectionArray), 7);
    window.collectionData = collectionArray;
    console.log("✅ window.collectionData =", window.collectionData);
  }, 100);
})();

(function renderFullBreadcrumb() {
  const interval = setInterval(() => {
    const wrapper = document.getElementById("breadcrumb-wrapper");
    if (!wrapper) return;

    clearInterval(interval);

    function getCookie(name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length === 2) return decodeURIComponent(parts.pop().split(";").shift());
    }

    const collectionDataRaw = getCookie("collectionData");
    if(!collectionDataRaw){
      const breadcrumbb = document.getElementById("breadcrumb-wrapper");
      if (!breadcrumbb) return;

      const listItems = breadcrumbb.querySelectorAll("li");
      if (listItems.length >= 2) {
        listItems[1].style.display = "inline-block";
      }
    }
    if (!collectionDataRaw) return;

    try {
      const collectionArray = JSON.parse(collectionDataRaw);

      // Render collections from cookie
      collectionArray.forEach((col, index) => {
        const li = document.createElement("li");

        if (index == collectionArray.length - 1 && document.body.classList.contains("template-product")) {
          // If we're on product page, don't link the last collection
          const a = document.createElement("a");
          a.href = "/collections/" + col.collection_handle;
          a.textContent = col.collection_title;
          li.appendChild(a);
        } else if (index === collectionArray.length - 1) {
          // Last item and not product page: plain text
          li.textContent = col.collection_title;
        } else {
          const a = document.createElement("a");
          a.href = "/collections/" + col.collection_handle;
          a.textContent = col.collection_title;
          li.appendChild(a);
        }

        wrapper.appendChild(li);
      });

      // ✅ Now add product title if on product page
      if (document.body.classList.contains("template-product")) {
        const productTitleEl = document.querySelector('[data-product-title]');
        if (productTitleEl) {
          const li = document.createElement("li");
          li.textContent = productTitleEl.dataset.productTitle;
          wrapper.appendChild(li);
        }
      }

    } catch (e) {
      console.warn("Invalid cookie JSON for breadcrumb", e);
    }
  }, 100);
})();

